import React from 'react';
import { sponsors } from '../data/sponsors';

const SponsorCarousel: React.FC = () => {
  const carouselSponsors = sponsors;

  // Duplicate sponsors for seamless scrolling
  const duplicatedSponsors =
    carouselSponsors.length > 1
      ? [...carouselSponsors, ...carouselSponsors, ...carouselSponsors]
      : carouselSponsors;

  return (
    <div className="sponsor-carousel-section">
      <div className="sponsor-carousel-container">
        <h3 className="sponsor-carousel-title">Sponsors</h3>
        <div className="sponsor-carousel-wrapper">
          <div className="sponsor-carousel-track">
            {duplicatedSponsors.map((sponsor, index) => (
              <div key={`${sponsor.id}-${index}`} className="sponsor-carousel-item">
                {sponsor.logo ? (
                  <a
                    href={sponsor.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sponsor-carousel-link"
                  >
                    <img
                      src={sponsor.logo}
                      alt={sponsor.name}
                      className={`sponsor-carousel-logo${sponsor.logoClass ? ` ${sponsor.logoClass}` : ''}`}
                    />
                  </a>
                ) : (
                  <div className="sponsor-carousel-placeholder">
                    <span>{sponsor.name}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SponsorCarousel;

